import { Injectable, inject } from '@angular/core';
import { CookieOptions, CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root',
})
export class WebStorageService {
  private cookieService = inject(CookieService);


  setCookie(
    name: string,
    value: string,
    persist = false,
    options?: CookieOptions
  ) {
    if (!persist) {
      this.cookieService.setCookie(name, value, { path: '/', ...options });
    } else {
      this.cookieService.setCookie(name, value, {
        expires: 1, // 1 day
        path: '/',
        ...options,
      });
    }
  }

  getCookie(name: string) {
    return this.cookieService.getCookie(name) ?? null;
  }

  removeCookie(name: string) {
    return this.cookieService.deleteCookie(name, '/');
  }
}
